module.exports = __webpack_public_path__ + "static/media/ticker_icon_dispatch.58528fb0.svg";